import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ExerciseCategoryItem } from "src/components/ExerciseCategoryItem";
import { SingleSelectCombobox } from "src/components/SingleSelectCombobox";
import { useExerciseCategories } from "src/state/exerciseCategories";
import { type TranslationKey } from "src/types";

export interface ExerciseCategoryComboboxProps {
  onChange: (s: string) => void;
  value: string;
  placeholder: string;
  notFoundText: string;
}

export const ExerciseCategoryCombobox = observer(function ExerciseFocusSelect(
  props: ExerciseCategoryComboboxProps,
) {
  const categories = useExerciseCategories();
  const { t } = useTranslation();

  const items = useMemo(
    () =>
      categories.map((category) => {
        return {
          id: category.id,
          label: t(`exerciseCategories.${category.name}` as TranslationKey),
          attributes: category.exerciseAttributes
            .map((attribute) => {
              return t(
                `workoutItemSets.attributes.${attribute.name}` as TranslationKey,
              );
            })
            .join(" × "),
        };
      }),
    [categories, t],
  );

  return (
    <SingleSelectCombobox
      items={items}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
      emptyText={props.notFoundText}
      renderItem={(item) => {
        return (
          <ExerciseCategoryItem
            label={item.label}
            attributes={item.attributes}
          />
        );
      }}
    />
  );
});
